<template>
  <v-dialog :value="value" max-width="700" @input="$emit('input', $event)">
    <v-card class="pb-2">
      <v-progress-linear v-if="loading" indeterminate color="primary" />
      <v-card-title class="headline">
        Привязать устройства
        <v-spacer />
        <v-btn
          icon
          text
          x-large
          class="btn__icon pa-0"
          width="18"
          height="18"
          @click="close"
        >
          <v-icon size="x-large">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-tabs v-model="activeTab" class="px-4" grow>
        <v-tab class="text-none">Домофоны</v-tab>
        <v-tab class="text-none">Шлагбаумы</v-tab>
      </v-tabs>

      <v-tabs-items v-model="activeTab">
        <v-tab-item>
          <v-col class="px-5 pb-1 pt-3">
            <v-text-field
              v-model="doorphoneSearch.address"
              placeholder="Поиск по адресу"
              solo
              outlined
              dense
              hide-details
              flat
            />
          </v-col>
          <v-col class="px-5 pb-1">
            <v-text-field
              v-model="doorphoneSearch.id"
              placeholder="Поиск по id"
              solo
              outlined
              dense
              hide-details
              flat
            />
          </v-col>
          <v-row class="pa-4 px-5">
            <v-col>
              <v-btn
                color="green"
                outlined
                class="text-none mr-2"
                rounded
                :loading="attaching"
                :disabled="!selectedDoorphones.length"
                @click="attachDoorphones"
              >
                Привязать
              </v-btn>
            </v-col>
            <v-spacer />
            <v-col class="text-right">
              <v-btn
                dark
                class="btn primary darken-3 white px-7 text-none"
                @click="searchDoorphones"
              >
                Поиск
              </v-btn>
            </v-col>
          </v-row>
          <v-data-table
            class="table row-click mx-5 pb-5"
            :items-per-page="10"
            :items="doorphones"
            :options.sync="doorphoneOptions"
            :server-items-length="doorphonesTotal"
            :headers="doorphoneHeaders"
            item-key="id"
            show-select
            :loading="loadingDoorphones"
            v-model="selectedDoorphones"
            @click:row="toggleDoorphoneSelect"
            :footer-props="{
              'items-per-page-options': [10, 20, 50],
              showFirstLastPage: true,
            }"
          >
            <template v-slot:item.address="{ item }">
              {{ formatDoorphoneAddress(item) }}
            </template>
          </v-data-table>
        </v-tab-item>

        <v-tab-item>
          <v-col class="px-5 pb-1 pt-3">
            <v-text-field
              v-model="barrierSearch.address"
              placeholder="Поиск по адресу"
              solo
              outlined
              dense
              hide-details
              flat
            />
          </v-col>
          <v-col class="px-5 pb-1">
            <v-text-field
              v-model="barrierSearch.id"
              placeholder="Поиск по id"
              solo
              outlined
              dense
              hide-details
              flat
            />
          </v-col>
          <div class="px-5 pb-2 body-2 grey--text text--darken-1">
            Только шлагбаумы без привязанных домофонов
          </div>
          <v-row class="pa-4 px-5">
            <v-col>
              <v-btn
                color="green"
                outlined
                class="text-none mr-2"
                rounded
                :loading="attaching"
                :disabled="!selectedBarriers.length"
                @click="attachBarriers"
              >
                Привязать
              </v-btn>
            </v-col>
            <v-spacer />
            <v-col class="text-right">
              <v-btn
                dark
                class="btn primary darken-3 white px-7 text-none"
                @click="searchBarriers"
              >
                Поиск
              </v-btn>
            </v-col>
          </v-row>
          <v-data-table
            class="table row-click mx-5 pb-5"
            :items-per-page="10"
            :items="barriers"
            :options.sync="barrierOptions"
            :server-items-length="barriersTotal"
            :headers="barrierHeaders"
            item-key="id"
            show-select
            :loading="loadingBarriers"
            v-model="selectedBarriers"
            @click:row="toggleBarrierSelect"
            :footer-props="{
              'items-per-page-options': [10, 20, 50],
              showFirstLastPage: true,
            }"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'MtoSectorAttachDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    sectorId: {
      type: [Number, String],
      required: true,
    },
    agentId: {
      type: [Number, String],
      default: null,
    },
    attachedIds: {
      type: Object,
      default: () => ({
        doorphone: [],
        barrier: [],
      }),
    },
  },
  data () {
    return {
      activeTab: 0,
      loading: false,
      attaching: false,
      loadingDoorphones: false,
      loadingBarriers: false,
      doorphones: [],
      barriers: [],
      doorphonesTotal: 0,
      barriersTotal: 0,
      selectedDoorphones: [],
      selectedBarriers: [],
      doorphoneSearch: { address: '', id: '' },
      barrierSearch: { address: '', id: '' },
      doorphoneOptions: { page: 1, itemsPerPage: 10 },
      barrierOptions: { page: 1, itemsPerPage: 10 },
      doorphoneHeaders: [
        { text: 'ID', value: 'id' },
        { text: 'Адрес', value: 'address', sortable: false },
        { text: 'Модель', value: 'device.model', sortable: false },
      ],
      barrierHeaders: [
        { text: 'ID', value: 'id' },
        { text: 'Название', value: 'name', sortable: false },
        { text: 'Адрес', value: 'address', sortable: false },
      ],
    };
  },
  watch: {
    value (open) {
      if (open) {
        this.resetState();
        this.searchDoorphones();
        this.searchBarriers();
      }
    },
    doorphoneOptions: {
      deep: true,
      handler () {
        if (this.value) {
          this.loadDoorphones();
        }
      },
    },
    barrierOptions: {
      deep: true,
      handler () {
        if (this.value) {
          this.loadBarriers();
        }
      },
    },
  },
  methods: {
    ...mapActions({
      getDoorphones: 'Doorphone/getExpandedDoorphones',
      loadAllBarriers: 'Barriers/loadAllBarriers',
      attachEquipment: 'MtoSector/attachEquipment',
    }),
    resetState () {
      this.activeTab = 0;
      this.selectedDoorphones = [];
      this.selectedBarriers = [];
      this.doorphoneSearch = { address: '', id: '' };
      this.barrierSearch = { address: '', id: '' };
      this.doorphoneOptions = { page: 1, itemsPerPage: 10 };
      this.barrierOptions = { page: 1, itemsPerPage: 10 };
    },
    close () {
      this.$emit('input', false);
    },
    formatDoorphoneAddress (doorphone) {
      let address = doorphone.address;
      if (doorphone.entrance > 0) {
        address = `${doorphone.address}, п.${doorphone.entrance}`;
      }
      return address;
    },
    toggleDoorphoneSelect (item) {
      const index = this.selectedDoorphones.findIndex(row => row.id === item.id);
      if (index === -1) {
        this.selectedDoorphones.push(item);
      } else {
        this.selectedDoorphones.splice(index, 1);
      }
    },
    toggleBarrierSelect (item) {
      const index = this.selectedBarriers.findIndex(row => row.id === item.id);
      if (index === -1) {
        this.selectedBarriers.push(item);
      } else {
        this.selectedBarriers.splice(index, 1);
      }
    },
    searchDoorphones () {
      this.doorphoneOptions.page = 1;
      this.loadDoorphones();
    },
    searchBarriers () {
      this.barrierOptions.page = 1;
      this.loadBarriers();
    },
    hasSectorAgent () {
      return this.agentId !== null && this.agentId !== undefined && this.agentId !== '';
    },
    async loadDoorphones () {
      this.loadingDoorphones = true;
      const filters = { type: 'M' };
      if (this.hasSectorAgent()) {
        filters.agent_id = this.agentId;
      }
      if (this.doorphoneSearch.address) {
        filters.address = this.doorphoneSearch.address;
      }
      if (this.doorphoneSearch.id) {
        filters.id = this.doorphoneSearch.id;
      }

      try {
        const request = {
          pagination: 1,
          page: this.doorphoneOptions.page,
          limit: this.doorphoneOptions.itemsPerPage,
          filters,
          include: ['device'],
        };
        if (this.doorphoneSearch.address) {
          request.sort = 'address';
        }
        const data = await this.getDoorphones(request);
        const attached = this.attachedIds.doorphone || [];
        this.doorphonesTotal = data.meta.total;
        this.doorphones = (data.doorphones || []).filter((item) => {
          const sectorId = item.mto_sector_id;
          const isAttachedHere = Number(sectorId) === Number(this.sectorId);
          const isAttachedElsewhere = sectorId && !isAttachedHere;
          return !isAttachedElsewhere && !attached.includes(item.id);
        });
      } catch (e) {
        this.$flash_warning('Не удалось загрузить домофоны');
      } finally {
        this.loadingDoorphones = false;
      }
    },
    async loadBarriers () {
      this.loadingBarriers = true;
      const filters = {
        passage_type: 'B',
        without_doorphones: 1,
      };
      if (this.hasSectorAgent()) {
        filters.agent_id = this.agentId;
      }
      if (this.barrierSearch.address) {
        filters.address = this.barrierSearch.address;
      }
      if (this.barrierSearch.id) {
        filters.id = this.barrierSearch.id;
      }

      try {
        const response = await this.loadAllBarriers({
          page: this.barrierOptions.page,
          limit: this.barrierOptions.itemsPerPage,
          filters,
        });
        const attached = this.attachedIds.barrier || [];
        const items = response.data || [];
        this.barriers = items.filter((item) => {
          const sectorId = item.mto_sector_id;
          const isAttachedHere = Number(sectorId) === Number(this.sectorId);
          const isAttachedElsewhere = sectorId && !isAttachedHere;
          return !isAttachedElsewhere && !attached.includes(item.id);
        });
        this.barriersTotal = (response.meta && response.meta.total) || items.length;
      } catch (e) {
        this.$flash_warning('Не удалось загрузить шлагбаумы');
      } finally {
        this.loadingBarriers = false;
      }
    },
    async attachDoorphones () {
      if (!this.selectedDoorphones.length) {
        this.$flash_warning('Выберите домофоны');
        return;
      }
      this.attaching = true;
      let attached = 0;
      try {
        for (const item of this.selectedDoorphones) {
          await this.attachEquipment({
            id: this.sectorId,
            data: { type: 'doorphone', id: item.id },
          });
          attached += 1;
        }
        this.$flash_success(`Привязано домофонов: ${attached}. Калитки подтянутся автоматически.`);
        this.$emit('attached');
        this.close();
      } catch (e) {
        this.handleError(e, 'Не удалось привязать домофоны');
      } finally {
        this.attaching = false;
      }
    },
    async attachBarriers () {
      if (!this.selectedBarriers.length) {
        this.$flash_warning('Выберите шлагбаумы');
        return;
      }
      this.attaching = true;
      let attached = 0;
      try {
        for (const item of this.selectedBarriers) {
          await this.attachEquipment({
            id: this.sectorId,
            data: { type: 'barrier', id: item.id },
          });
          attached += 1;
        }
        this.$flash_success(`Привязано шлагбаумов: ${attached}`);
        this.$emit('attached');
        this.close();
      } catch (e) {
        this.handleError(e, 'Не удалось привязать шлагбаумы');
      } finally {
        this.attaching = false;
      }
    },
    handleError (err, fallback) {
      if (err.response && err.response.status === 422) {
        const response = err.response.data;
        Object.keys(response).forEach((input) => {
          if (Array.isArray(response[input])) {
            response[input].forEach(error => this.$flash_warning(error));
          }
        });
      } else if (err.response && err.response.data && err.response.data.error) {
        this.$flash_warning(err.response.data.error);
      } else {
        this.$flash_warning(fallback);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.row-click {
  cursor: pointer;
}
</style>
